import { render } from "./Card3.vue?vue&type=template&id=de6df2d2&ts=true"
import script from "./Card3.vue?vue&type=script&lang=ts"
export * from "./Card3.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/kemet/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__